export default __webpack_public_path__ + "static/media/Analytics_Mobile.38b2832e.svg";